import { Box, Spinner } from '@chakra-ui/react';
import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import { useAlert } from '@app/hooks/use-alert';
import { useApi } from '@app/hooks';

import { EquipmentsRepairFormInstance } from './types';
import EquipmentsRepairForm from './form';
import { Paper } from '../common';

type EquipmentsRepairEditProps = {};

const EquipmentsRepairEdit: FC<EquipmentsRepairEditProps> = () => {
  const { info, error } = useAlert();
  const api = useApi();
  const params = useParams<{ id: string }>();

  const history = useHistory();

  const [instance, setInstance] = useState<
    EquipmentsRepairFormInstance | undefined
  >(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (params.id) {
      setLoading(true);
      (async () => {
        const response = await api.equipments.getEquipmentsRepair(params.id);
        setInstance({ 
          ...response.data,
          service_data: {
            ...response.data.service_data,
            outlet: {
              ...response.data.service_data.outlet,
              name: response.data.service_data.outlet?.name || response.data.service_data.outlet?.outlet_name
            },
            address: {
              full_address: response.data.service_data.full_address,
            }
          }
        });
        setLoading(false);
      })();
    }
  }, [params.id]);

  const onFormSubmit = async (
    instance: Partial<EquipmentsRepairFormInstance>
  ) => {
    const resp = await api.equipments.putEquipmentsRepair({
      id: instance.id,
      equip_id: instance.equip_id,
      problem_id: Number(instance.service_data.problem.id),
      type_id: Number(instance.type.id),
      department_id: Number(instance.department?.id),
      brand_id: Number(instance.service_data.brand?.id),
      manufacturer_id: Number(instance.service_data.manufacturer.id),
      model_id: Number(instance.service_data.model.id),
      inventory_num: instance.service_data.inventory_num,
      serial_num: instance.service_data.serial_num,
      production_date: Number(instance.service_data.production_date),
      outlet_id: instance.service_data.outlet.id ? Number(instance.service_data.outlet.id) : undefined,
      outlet_name:
        instance.service_data.outlet.legal_name || 
        instance.service_data.outlet.outlet_name,
      address: instance.service_data.address.full_address,
      comment: instance.service_data.comment,
      contacts: instance.contacts,
    });
    if (resp.code === 200) {
      info('Заявка успешно изменена');
      history.goBack();
    } else {
      error(`Ошибка при изменении заявки: ${resp.message}`);
    }
  };

  const onFormCancel = () => {
    history.goBack();
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          {loading ? (
            <Box
              width="100%"
              height="300px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Spinner />
            </Box>
          ) : (
            <EquipmentsRepairForm
              instance={instance}
              onSubmit={onFormSubmit}
              onCancel={onFormCancel}
              submitText="Изменить"
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default EquipmentsRepairEdit;
